import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { t } from '../../i18n';

export default function MetricValue({ value, label, icon: Icon, short = false, large = false }) {
    return <Box sx={{
        minWidth: 0, display: 'grid', alignItems: 'center',
        gridTemplateColumns: { xs: (short ? '18px' : '30px') + ' minmax(0, 1fr)',
            sm: (short ? '26px' : large ? '42px' : '38px') + ' minmax(0, 1fr)' },
        columnGap: short ? 0.75 : { xs: 1, sm: 1.75 }
    }}>
        <Icon aria-hidden="true" sx={{
            color: 'primary.main', fontSize: { xs: short ? 18 : 30, sm: short ? 26 : large ? 42 : 38 },
            gridColumn: 1, gridRow: { xs: short ? '1' : '1 / 3', sm: '1 / 3' }
        }} />
        <Typography component="p" color="primary.main" sx={{
            gridColumn: 2, gridRow: 1, fontSize: { xs: short ? 19 : 26, sm: short ? 22 : large ? 32 : 30 },
            fontWeight: 700, lineHeight: 1.1
        }}>{value}</Typography>
        <Typography variant="caption" color="text.secondary" sx={{
            gridColumn: { xs: short ? '1 / -1' : '2', sm: '2' }, gridRow: 2,
            fontSize: short ? 10 : { xs: 11, sm: 12 }, lineHeight: 1.25, mt: 0.5,
            overflowWrap: 'break-word'
        }}>{t(label)}</Typography>
    </Box>;
}
MetricValue.propTypes = {
    value: PropTypes.node.isRequired, label: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired, short: PropTypes.bool, large: PropTypes.bool
};
